import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import M from 'materialize-css';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { Link } from 'react-router-dom';
import { badgesType } from '../../constants/constants';

const refModal = React.createRef();

function NewPlaceSearch(props) {
  const [companyName, setCompanyName] = useState('');
  const [uidCompany, setUidCompany] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [type, setType] = useState('');
  const [searchName, setSearchName] = useState('');
  const [currentCompanies, setCurrentCompanies] = useState([]);
  const [redirecToPlaceSearchList, setRedirecToPlaceSearchList] = useState(false);
  const { firestore, companies, placeSearch, edit } = props;

  useEffect(() => M.AutoInit(), [country]);
  
  const setPlaceSearch = (placeSearch) => {
    setCompanyName(placeSearch.companyName);
    setUidCompany(placeSearch.uidCompany);
    setCountry(placeSearch.country);
    if (placeSearch.state) setState(placeSearch.state);
    if (placeSearch.city) setCity(placeSearch.city);
    if (placeSearch.type) setType(placeSearch.type);
  };

  const filterCompanies = useCallback((country, companyName) => {
    if (!companies) return;
    let filteredCompanies = companies.filter((company) => {
      return company.countryCode === country && (companyName !== '' ? company.companyName.toLowerCase().includes(companyName.toLowerCase()) : true);
    });
    setCurrentCompanies(filteredCompanies);
  }, [companies]);

  useEffect(() => {
    if (placeSearch) {
      setPlaceSearch(placeSearch);
      filterCompanies(placeSearch.country, '');
    }
  }, [country, placeSearch, filterCompanies]);

  const createPlaceSearch = () => {
    const newPlaceSearch = {
      updatedAt: firestore.FieldValue.serverTimestamp(),
      companyName: companyName,
      uidCompany: uidCompany,
      state: state,
      country: country,
      city: city,
    };
    if (type !== '') newPlaceSearch.type = type;
    if (!validatePlaceSearch()) {
      alert('Please fill in all the minimum fields');
      return;
    }
    let query = firestore.collection('placesSearch');
    if (edit) {
      query = query.doc(placeSearch.id).set(newPlaceSearch, { merge: false });
    } else {
      const newRef = query.doc();
      query = newRef.set({ id: newRef.id, ...newPlaceSearch });
    }
    query.then(() => setRedirecToPlaceSearchList(true)).catch((error) => console.error(error));
  };

  const validatePlaceSearch = () => companyName.trim() !== '' && uidCompany.trim() !== '' && country.trim() !== '' && (state.trim() !== '' || city.trim() !== '');

  const openCompanyDialog = () => {
    const modal = M.Modal.getInstance(refModal.current);
    modal.open();
  };

  const updateCountry = (country) => {
    setCountry(country);
    filterCompanies(country, '');
  };

  const search = (searchTerm) => {
    setSearchName(searchTerm);
    filterCompanies(country, searchTerm);
  };

  const renderCompanyDialog = () => {
    return (
      <div ref={refModal} className="modal">
        <div className="modal-content">
          <h5>Company UID</h5>
          <div className="row">
            <div className="input-field col s12">
              <input
                id="searchName"
                type="text"
                className="validate"
                value={searchName}
                name="searchName"
                onChange={(e) => {
                  search(e.target.value);
                }}
              />
              <label htmlFor="searchName">Company name</label>
            </div>
          </div>
          <div className="search-container">
            {currentCompanies.map((company) => {
              return (
                <div key={company.id}>
                  <a
                    href="#!"
                    onClick={(e) => {
                      setUidCompany(company.uid);
                      search('');
                    }}
                    className="modal-close waves-effect btn btn-flat">
                    {company.companyName}
                  </a>
                </div>
              );
            })}
          </div>
        </div>
        <div className="modal-footer">
          <a
            href="#close"
            className="modal-close waves-effect btn btn-flat"
            onClick={(e) => {
              search('');
            }}>
            {' '}
            Cancel
          </a>
        </div>
      </div>
    );
  };

  useEffect(() => {
    var elems = document.querySelectorAll('select');
    M.FormSelect.init(elems, {});
  }, []);

  const renderTypeSelect = () => {
    const types = [];
    for (const key in badgesType) types.push(badgesType[key]);
    return (
      <div className="row">
        <div className="input-field col s12">
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="">Select a type</option>
            {types.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
          <label>Type</label>
        </div>
      </div>
    );
  };

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;
  if (redirecToPlaceSearchList) return <Redirect to="/places" />;

  return (
    <div className="container">
      <div className="card z-depth-2 project-summary">
        <form className="col s12 new-form">
          <div className="card-content">
            <div className="row">
              <h3>{`${edit ? 'Edit' : 'New'} Place Search`}</h3>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <select
                  className="icons"
                  value={country}
                  onChange={(e) => {
                    updateCountry(e.target.value);
                  }}>
                  <option value="" disabled>
                    Select your Country
                  </option>
                  <option data-icon="images/ca.svg" value="CA">
                    Canada
                  </option>
                  <option data-icon="images/us.svg" value="US">
                    United States
                  </option>
                  <option data-icon="images/bo.svg" value="BO">
                    Bolivia
                  </option>
                </select>
                <label>Country</label>
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <input id="state" type="text" className="validate" name="state" value={state} onChange={(e) => setState(e.target.value)} />
                <label htmlFor="state" className="active">
                  State
                </label>
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <input id="city" type="text" className="validate" name="city" value={city} onChange={(e) => setCity(e.target.value)} />
                <label htmlFor="city" className="active">
                  City
                </label>
              </div>
            </div>
            {renderTypeSelect()}
            <div className="row">
              <div className="input-field col s12">
                <input id="company_name" type="text" className="validate" name="companyName" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                <label htmlFor="company_name" className="active">
                  Company Name
                </label>
              </div>
            </div>
            <div className="row">
              <div className="input-field">
                <div className="col s6">
                  <label htmlFor="company_uid">Company UID</label>
                  <input id="company_uid" type="text" name="uidCompany" value={uidCompany} onChange={(e) => setUidCompany(e.target.value)} />
                </div>
                <div className="col s6">
                  <Link to="#" onClick={(e) => openCompanyDialog()}>
                    Select company
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {renderCompanyDialog()}
          <div className="card-action">
            <a href="#create" className="waves-effect waves-light btn btn-large" onClick={createPlaceSearch}>
              {edit ? 'Update' : 'Create'}
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    companies: state.firestore.ordered.companies,
    auth: state.firebase.auth,
    placeSearch: ownProps.location.placeSearch,
    edit: ownProps.location.edit,
  };
};

export default compose(firestoreConnect([{ collection: 'companies', orderBy: ['companyName', 'asc'] }]), connect(mapStateToProps))(NewPlaceSearch);
